export default "__VITE_ASSET__9DoCTcur__"